import { combineReducers } from 'redux';

import systemAlert from 'presentation/redux/modules/systemAlert/reducer';
import sessionParams from 'presentation/redux/modules/sessionParams/reducer';

export default combineReducers({
    systemAlert,
    sessionParams
});